import Tire from './tire';
import Wheel from './wheel';
import Tread from './tread';
import Tabs from '../../tabs';

class ProductSelectorEmbed {
  dom: {
    root: HTMLElement;
    tabs: HTMLElement[];
  };

  tablist!: Tabs;

  modules!: {
    tire: Tire;
    wheel: Wheel;
    tread: Tread;
  };

  /**
   * Product selector element logic. Basically the tabbing functionality.
   * Each tab can contain its own logic.
   *
   * @param {HTMLElement} element - Root element of the product selector
   */
  constructor(element: HTMLElement) {
    // Define elements
    this.dom = {
      root: element,
      tabs: Array.from(element.querySelectorAll('[role="tabpanel"]')),
    };

    this.modules = {} as any;

    const tablistElement = element.querySelector('[role="tablist"]') as HTMLElement;
    if(tablistElement) {
      this.tablist = new Tabs(tablistElement);
    }

    // Load selectors per tab
    this.dom.tabs.forEach(tabEl => {
      if (tabEl.dataset.type === 'tire') {
        this.modules.tire = new Tire(tabEl, this);
      }

      if (tabEl.dataset.type === 'wheel') {
        this.modules.wheel = new Wheel(tabEl, this);
      }

      if (tabEl.dataset.type === 'tread') {
        this.modules.tread = new Tread(tabEl, this);
      }
    });
  }

  /**
   * Sets loading state for entire tyre selector
   */
  setLoading(state: boolean) {
    this.dom.root.classList.toggle('loading', state);
  }
}

export default ProductSelectorEmbed;

export async function init(elements) {
  console.log('[NHT ProductSelectorEmbed]: init');
  for (let element of elements) {
    new ProductSelectorEmbed(element);
  }
}
